<template>
  <b-alert @input="$emit('show', $event)" :show="showError" variant="danger" dismissible>
    <ul class="mb-0" :class="{ 'list-unstyled': errors && errors.length === 1 }">
      <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
    </ul>
  </b-alert>
</template>

<script>
/**
 * This component can be used to show error inline
 *
 * Props:
 * - errors: List of errors to be show
 * - showError: a boolean property which directs this component to show/hide error
 *
 * Emits:
 * - show: This event is emitted when Alert changes its visibility
 */
import { BAlert } from 'bootstrap-vue'

export default {
  name: 'ErrorAlert',
  components: { BAlert },
  props: ['errors', 'showError'],
  data() {
    return { show: this.showError }
  },
  watch: {
    showError() {
      this.show = this.showError
    }
  }
}
</script>

<style scoped></style>
